
import DeadlineOverview from "../../Activities/ActivityOverview/DeadlineOverview";

const DeadlineOverviewPage = () => {
  return <DeadlineOverview />;
};

export default DeadlineOverviewPage;
